import {ErrorWrapper, ResponseWrapper} from '@/core/service/util'
import {RoomBaseApiService} from '@/core/service/room.baseapi.service'
import {Http} from '@/core/service/http.init'

class RoomMeetingNoteService extends RoomBaseApiService {
  constructor() {
    super()
  }
  
  async getMeetingNoteList() {
    try {
      const response = await this.request().get(
          `/api/v3/room/${this.getRoomId()}/meetingNote/list`
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async startMeetingNote(params) {
    try {
      const response = await this.request().post(
          `/api/v3/room/${this.getRoomId()}/meetingNote/start`, {
            ...params
          }
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async stopMeetingNote(params) {
    try {
      const response = await this.request().post(
          `/api/v3/room/${this.getRoomId()}/meetingNote/stop`, {
            ...params
          }
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async deleteMeetingNote(params) {
    try {
      const response = await this.request().post(
          `/api/v3/room/${this.getRoomId()}/meetingNote/delete`, {
            ...params
          }
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }


  async summarizeMeetingNote(params) {
    try {
      const response = await this.request().post(
          `/api/v3/room/${this.getRoomId()}/meetingNote/summarize`, {
            ...params
          }
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async getMeetingNote(params) {
    try {
      const response = await this.request().post(
          `/api/v3/room/${this.getRoomId()}/meetingNote`, {
            ...params
          }
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }
  

  async getMeetingNoteSummary(params) {
    try {
      const response = await this.request().post(
          `/api/v3/room/${this.getRoomId()}/meetingNote/summary`, {
            ...params
          }
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

}

export const roomMeetingNoteService = new RoomMeetingNoteService()
